import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { ControlContainer, NgForm } from '@angular/forms';
import { WorkflowComponent } from '../../workflow.component';
import { isNullOrUndefined } from '../../../_infrastructure/objectUtils';

@Component({
    selector: 'subscriber-payment-information',
    templateUrl: './subscriber-payment-information.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class SubscriberPaymentInformationComponent implements OnInit, OnDestroy, ICardComponent {
  public cardData: models.SubscriberPaymentInformationVM = {} as models.SubscriberPaymentInformationVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.bankAccountTypes)
  public bankAccountTypes: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];

  public parentWorkflow: WorkflowComponent;
  public voluntary: boolean;
  constructor(private http: HttpClient, private activeRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    if (this.isVersion2) {
      this.voluntary = this.isVoluntary();
      if (this.cardData.bankAccountTypeCode === "undefined")
        this.cardData.bankAccountTypeCode = undefined;
    }
  }

  ngDoCheck() {
    if (this.isVersion2()) {
      if (isNullOrUndefined(this.voluntary)) {
        this.voluntary = this.isVoluntary();
      }
    }
  }

  ngOnDestroy(): void {
  }

  isVersion2() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  isInPt() {
    if (this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo['SubscriberContacts'] !== undefined && this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo['SubscriberContacts'].countryCode === 'PT')
      return true;
    else
      return false;
  }

  isWorkflowCompulsoryAndOnService(): boolean {
    let isService = !this.isWorkflowOnSubscriber;
    let isCompulsory = !this.isVoluntary();

    return isService && isCompulsory;
  }

  isVoluntary(): boolean {
    let result = false;
    let voluntaryFundaments = ['PEDI001A', 'PEDI001B', 'PEDI001C', 'PEDI001D', 'PEDI001L', 'PEDI001F', 'PEDI001H', 'PEDI001I', 'PEDI001K', 'PEDI001O', 'PEDI001P', 'PEDI001S', 'PEDI001T', 'PEDI001V', 'PEDI001X', 'PEDI001Y', 'PEDI001Z', 'PEDI001AB', 'PEDI001AC', 'PEDI001AD'];
    if (voluntaryFundaments.indexOf(this.parentWorkflow['workflowInstance']['workflowCode']) >= 0 || this.parentWorkflow['workflowInstance']['workflowCode'].indexOf('PEDI005') > -1 || this.parentWorkflow['workflowInstance']['workflowCode'].indexOf('PEDI008') > -1) {
      result = true;
    }

    return result;
  }
}
